import { render, staticRenderFns } from "./BlogPagination.vue?vue&type=template&id=b779268a&scoped=true&"
import script from "./BlogPagination.vue?vue&type=script&lang=js&"
export * from "./BlogPagination.vue?vue&type=script&lang=js&"
import style0 from "./BlogPagination.vue?vue&type=style&index=0&id=b779268a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b779268a",
  null
  
)

export default component.exports